import React, {useEffect, useState} from 'react';
import Dialog from "components/Dialog";
import {TextField} from "@material-ui/core";
import Tr from "translations/Translations";
import SingleButton from "components/popup/components/SingleButton";
import {connect} from "react-redux";
import DemandOffersService from "services/DemandOffersService";
import isResponseValid from "libs/isResponseValid";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import BoldTypography from "components/BoldTypography";
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import WorkableButton from "components/button/WorkableButton";
import {ContractorPasswordState} from "constants/ContractorPasswordState";
import {useParams} from "react-router";


const DefineOfferPasswordPopup = (
    {
        popupConfig
    }) => {
    const params = useParams();
    const [passwordInfo, setPasswordInfo] = useState(null);
    const [error, setError] = useState(null);
    const [working, setWorking] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState(null);


    useEffect(() => {
        if (popupConfig) {
            DemandOffersService.getPasswordStatus(params.id, params.stageId)
                .then((resp) => {
                    if (isResponseValid(resp, setError)) {
                        if (resp.result.state === ContractorPasswordState.HAS_PASSWORD_STORED) {
                            onSuccess();
                        }
                        setPasswordInfo(resp.result)
                    }
                })
                .catch(onError);
        } else {
            setPasswordInfo(null);
            setError(null);
            setWorking(false);
            setPassword("");
            setPasswordError(null);
        }
        // eslint-disable-next-line
    }, [popupConfig])

    const onError = () => {
        if (popupConfig && popupConfig.errorCallback) popupConfig.errorCallback();
        DemandOffersService.clearResources(DemandOffersService.DEMAND_CONTRACTOR_PASSWORD_POPUP);
    }
    const onSuccess = () => {
        if (popupConfig && popupConfig.successCallback) popupConfig.successCallback();
        DemandOffersService.clearResources(DemandOffersService.DEMAND_CONTRACTOR_PASSWORD_POPUP);
    }

    const onStorePassword = () => {
        if (working)
            return;

        setWorking(true);
        DemandOffersService.savePassword(params.id, params.stageId, password).then(resp => {
            if (isResponseValid(resp, setPasswordError)) {
                onSuccess();
            } else {
                setWorking(false);
            }
        }).catch(() => setWorking(false))

    }

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') {
            onStorePassword();
        }
    }

    if (!popupConfig) {
        return null;
    }
    return (<Dialog
        open
        titleCentered
        maxWidth={'md'}
        fullWidth={true}
        onClose={onError}
        dialogActions={<SingleButton
            justify='flex-end'
            label={Tr('cancel')}
            onClick={onError}
            variant="outlined"
            disabled={working}
        />}
        loading={!passwordInfo && !error}
    >

        {!!error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{error}</TypographyWithIcon>}
        {!!passwordInfo && <>
            <BoldTypography>{passwordInfo.title}</BoldTypography>
            <br/>
            <Typography dangerouslySetInnerHTML={{__html: passwordInfo.messageHtml}}/>

            {!!passwordError && <Typography color="error">{passwordError}</Typography>}
            <GridBlock
                justify="center"
                alignItems="flex-end"
            >
                <TextField
                    label={Tr('access_code')}
                    disabled={working}
                    onKeyUp={handleKeyUp}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <WorkableButton
                    working={working} disabled={password === ''} onClick={() => onStorePassword()}>{Tr('confirm')}</WorkableButton>
            </GridBlock>
        </>}
    </Dialog>)

}


DefineOfferPasswordPopup.propTypes = {};

export default connect((state) => ({
    popupConfig: state.resources[DemandOffersService.DEMAND_CONTRACTOR_PASSWORD_POPUP]
}))(DefineOfferPasswordPopup);